import katex from "katex";

/**
 * Converts a string in the format "numerator/denominator" to a KaTeX fraction
 * @param value - The fraction string to convert (e.g. "1/2")
 * @returns The KaTeX rendered fraction HTML or the original string if conversion fails
 */
export const convertToFraction = (value: string) => {
  // 숫자/숫자 형식인지 확인
  const fractionRegex = /^(\d+)\/(\d+)$/;
  const match = value.match(fractionRegex);

  if (match) {
    const [_, numerator, denominator] = match;
    try {
      return katex.renderToString(`\\frac{${numerator}}{${denominator}}`, {
        throwOnError: false,
        displayMode: false,
      });
    } catch (e) {
      return value;
    }
  }
  return value;
};
